import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=3fdc0472&scoped=true"
import script from "./InputCheckbox.vue?vue&type=script&lang=js"
export * from "./InputCheckbox.vue?vue&type=script&lang=js"
import style0 from "./InputCheckbox.vue?vue&type=style&index=0&id=3fdc0472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc0472",
  null
  
)

export default component.exports